import React from 'react';
import { Typo } from '@ers/ui';

const faqs = [
    {
        question: 'Szukam pracy',
        answer: () => (
            <Typo.Body>
        Korzystasz z Konta Kandydata eRecruiter. To narzędzie skierowane do
        kandydatów aplikujących przez formularz aplikacyjny dostarczany
        pracodawcom przez firmę eRecruiter. Konto służy do zbierania i
        porządkowania wszystkich Twoich danych przesyłanych przez formularze
        aplikacyjne eRecruiter. Z kolei firmom, a dokładnie działom rekrutacji
        oferujemy system rekrutacyjny eRecruiter. To narzędzie do zarządzania
        rekrutacjami, z którego korzysta pracodawca, do którego aplikowałeś/aś.
                <br />
                <br />
        Nie jesteśmy portalem pracy, na którym można wyszukiwać oferty. Aby
        znaleźć ogłoszenie danego pracodawcy, możesz wykonać dwa działania:
                <br />
        1. przejdź na stronę
                {' '}
                <Typo.Link
                    target="_blank"
                    rel="noopener noreferrer"
                    url="https://www.pracuj.pl/praca?utm_source=erecruiter&utm_medium=konto&utm_campaign=faq_er"
                    style={{ display: 'inline' }}
                >
          Pracuj.pl
                </Typo.Link>
                {' '}
        i wyszukaj tam nowe oferty
                <br />
        2. lub wyszukaj w Internecie stronę kariery pracodawcy (dostępną
        zazwyczaj na stronie www danej firmy). Jeśli znajdziesz interesującą
        ofertę, prześlij swoje dokumenty do pracodawcy za pomocą formularza,
        który znajduje się pod przyciskiem &quot;Aplikuj&quot;.
            </Typo.Body>
        )
    },
    {
        question: 'Mam pytanie o status mojej aplikacji',
        answer: () => (
            <Typo.Body>
        Korzystasz z Konta Kandydata eRecruiter. To narzędzie skierowane do
        kandydatów aplikujących przez formularz aplikacyjny dostarczany
        pracodawcom przez firmę eRecruiter. Konto służy do zbierania i
        porządkowania wszystkich Twoich danych przesyłanych przez formularze
        aplikacyjne eRecruiter. Z kolei firmom, a dokładnie działom rekrutacji
        oferujemy system rekrutacyjny eRecruiter. To narzędzie do zarządzania
        rekrutacjami, z którego korzysta pracodawca, do którego aplikowałeś/aś.
                <br />
                <br />
        Nie prowadzimy procesów rekrutacyjnych w imieniu naszych klientów. Nie
        posiadamy również informacji na temat szczegółów prowadzonych przez
        naszych klientów rekrutacji. Są to dane wewnętrzne naszych klientów.
        Jeżeli chcesz dowiedzieć się na temat swojej aplikacji, skontaktuj się
        bezpośrednio z pracodawcą, do którego aplikację złożyłeś/aś. Dane
        kontaktowe powinny być dostępne na stronie www danej firmy lub w
        potwierdzeniu e-mail otrzymanym po złożeniu aplikacji.
            </Typo.Body>
        )
    },
    {
        question: 'Jak odstąpić od umowy?',
        answer: () => (
            <Typo.Body>
        Możesz odstąpić od umowy na dwa sposoby:
                <br />
        1. samodzielnie usuń konto. Jeśli zdecydujesz się rozwiązać umowę tą
        drogą (opcja usunięcia dostępna jest w Ustawieniach) to nie musisz
        dodatkowo dostarczać do nas wspomnianego oświadczenia.
                <br />
        2. wyślij do nas na adres
                {' '}
                <Typo.Link
                    url="mailto:kandydat@erecruiter.pl?subject=Jak odstąpić od umowy?"
                    style={{ display: 'inline' }}
                >
          kandydat@erecruiter.pl
                </Typo.Link>
                {' '}
        oświadczenie odstąpienia od umowy. Oświadczenie powinno zawierać Twoje
        imię i nazwisko oraz adres e-mail, na który zostało założone Konto
        Kandydata.
                <br />
                <br />
        Będziemy wdzięczni za podanie powodu rezygnacji z Konta Kandydata. Taka
        informacja przyda się nam, aby udoskonalać nasze usługi. Pamiętaj, że
        korzystanie z Konta Kandydata oraz jego funkcji jest w pełni bezpłatne.
            </Typo.Body>
        )
    },
    {
        question: 'Jak usunąć swoje dane?',
        answer: () => (
            <Typo.Body>
        Chcemy ułatwić Ci zarządzanie Twoimi ustawieniami prywatności, dlatego
        też przygotowaliśmy możliwość samodzielnego usunięcia konta z poziomu
        ustawień usługi Konto Kandydata.
                <br />
                <br />
        Zaloguj się do swojego Konta Kandydata. Następnie przejdź do Ustawień i
        wybierz opcję &quot;Usuwanie konta&quot;. Usunięcie konta jest
        nieodwracalnie i spowoduje skasowanie wszystkich Twoich danych, które
        masz na Koncie Kandydata. Nie wpłynie to w żaden sposób na aplikacje,
        które wysłałeś/aś do pracodawców. Jednocześnie zaznaczamy, że
        aktualizacja ustawień w naszym systemie trwa do 24 godzin, zatem prosimy
        o wyrozumiałość w ciągu najbliższej doby.
                <br />
                <br />
W przypadku jakichkolwiek pytań lub wątpliwości związanych z
        przetwarzaniem danych osobowych w ramach Konta Kandydata, serdecznie
        zachęcamy do zapoznania się z naszą
                {' '}
                <Typo.Link
                    target="_blank"
                    rel="noopener noreferrer"
                    url="https://kandydat.erecruiter.pl/_files/Polityka_Prywatnosci_Konto_Kandydata_2022-01-20.pdf"
                    style={{ display: 'inline' }}
                >
          Polityką Prywatności
                </Typo.Link>
                {' '}
        lub do kontaktu z nami pod adresem
                {' '}
                <Typo.Link
                    url="mailto:kandydat@erecruiter.pl?subject=Jak usunąć swoje dane?"
                    style={{ display: 'inline' }}
                >
          kandydat@erecruiter.pl
                </Typo.Link>
                <br />
                <br />
        Pamiętaj, że korzystanie z Konta Kandydata oraz jego funkcji jest w
        pełni bezpłatne.
            </Typo.Body>
        )
    },
    {
        question: 'Czy Konto Kandydata jest płatne?',
        answer: () => (
            <Typo.Body>
        Korzystanie z Konta Kandydata oraz jego funkcji jest w pełni bezpłatne.
        Informacja ta znajduje się w punkcie 3 podpunkt 1
                {' '}
                <Typo.Link
                    target="_blank"
                    rel="noopener noreferrer"
                    url="https://erecruiter.pl/_files/konto_kandydata/Regulamin_swiadczenia_uslugi_Konto_Kandydata_2026-03-16.pdf"
                    style={{ display: 'inline' }}
                >
          Regulaminu Konta Kandydata
                </Typo.Link>
            </Typo.Body>
        )
    },
    {
        question: 'Chcę zgłosić błąd',
        answer: () => (
            <Typo.Body>
        Jeśli przypuszczasz, że zauważyłeś/aś błąd w Koncie Kandydata, napisz o
        tym na adres
                {' '}
                <Typo.Link
                    url="mailto:kandydat@erecruiter.pl?subject=Chcę zgłosić błąd"
                    style={{ display: 'inline' }}
                >
          kandydat@erecruiter.pl
                </Typo.Link>
        . Opisz na czym polega problem oraz na jakim urządzeniu i przeglądarce
        go zauważyłeś/aś.
            </Typo.Body>
        )
    },
    {
        question: 'Jak logować się do Konta Kandydata?',
        answer: () => (
            <Typo.Body>
        W Koncie Kandydata nie używany standardowego loginu i hasła. Zamiast
        tego wyślemy Ci na adres e-mail link do szybkiego logowania. Wystarczy,
        że w niego klikniesz i Cię zalogujemy.
                <br />
                <br />
        To bezpieczne rozwiązanie, bo każde konto jest powiązane z jednym
        adresem e-mail, do którego ma dostęp tylko właściciel tej poczty.
        Dlatego link do logowania do Twojego konta wyślemy tylko na Twoją
        skrzynkę. Dla dodatkowego bezpieczeństwa link do logowania jest
        jednorazowy i ważny tylko przez 24 godziny. Dopóki nie udostępnisz go
        nikomu, tylko Ty możesz dostać się do swojego konta. Pamiętaj więc, żeby
        nie przesyłać dalej wiadomości e-mail z linkiem.
            </Typo.Body>
        )
    },
    {
        question: 'W jaki sposób mogę pobrać swoje dane?',
        answer: () => (
            <Typo.Body>
        Zaloguj się do swojego Konta Kandydata. Następnie przejdź do Ustawień i
        wybierz opcję &quot;Eksport danych&quot;. Po chwili wygeneruje się plik
        z danymi, który możesz pobrać na swoje urządzenie.
            </Typo.Body>
        )
    },
    {
        question: 'Mam inne pytanie',
        answer: () => (
            <Typo.Body>
        Jeśli nie znalazłeś/aś tu odpowiedzi na swoje pytanie, napisz do nas na
                {' '}
                <Typo.Link
                    url="mailto:kandydat@erecruiter.pl?subject=Mam inne pytanie"
                    style={{ display: 'inline' }}
                >
          kandydat@erecruiter.pl
                </Typo.Link>
            </Typo.Body>
        )
    }
];
export default faqs;
